import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { apiService } from './services/api';
import authReducer from './slices/authSlice';
import homepageReducer from './slices/homepageSlice';

export const store = configureStore({
  reducer: {
    // Add the API reducer
    [apiService.reducerPath]: apiService.reducer,
    
    // Add other reducers
    auth: authReducer,
    homepage: homepageReducer,
  },
  
  // Add the API middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiService.middleware),
});

// Enable refetchOnFocus and refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;

